import React from 'react';
import Image from 'components/Image';

import STRINGS from '../../config/localizedStrings';
import withConfig from 'components/ConfigProvider/withConfig';
import { ActionNotification } from '../../components';
import { EditWrapper } from 'components';
import { Link } from 'react-router'

const HeaderSection = ({
	title,
	children,
	openContactForm,
	icon,
	iconId,
	stringId,
	icons: ICONS,
}) => {

	const helpclick = () =>{
		document.querySelector('.app-menu-bar-side .app-menu-bar-side_list:nth-child(8)').click()
	}

	return (
		<div className="header_title-wrapper d-flex flex-column w-100 f-1">
			<div className="d-flex justify-content-between ws-trade-head">
				<div className="d-flex align-items-center flex-lg-row flex-column ">
					<div className="ws-lock d-lg-flex d-none">
						<Image icon={process.env.PUBLIC_URL + "/assets/images/lock.png"} />
					</div>
					<div className="d-flex flex-column pl-4">
						<span className='ws-trade-tabe-head'>
							Settings
						</span>
						<span className='ws-trade-tabe-p'>
							Change the settings of your account. From interface, notifcations, username and
							other customizations.Saving your settings will apply the changes and save it.
						</span>
					</div>
				</div>
				<div className='d-lg-flex d-none align-items-center '>

					<span className="trade_tabs-link">
						<span className='text-light' style={{color:'#fff',cursor:'pointer'}} onClick={()=>helpclick()}>Need Help?</span>
					</span>
				</div>
			</div>
		</div>
	);
};

export default withConfig(HeaderSection);
